/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Unpublish_Confirm_Website_OnlyInputs */

const cs_property_unpublish_confirm_website_only = /** @type {(inputs: Property_Unpublish_Confirm_Website_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skrýt pouze na webu (žádný portál není zapnutý).`)
};

const en_property_unpublish_confirm_website_only = /** @type {(inputs: Property_Unpublish_Confirm_Website_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hide on the website only (no portal is enabled).`)
};

/**
* | output |
* | --- |
* | "Hide on the website only (no portal is enabled)." |
*
* @param {Property_Unpublish_Confirm_Website_OnlyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_unpublish_confirm_website_only = /** @type {((inputs?: Property_Unpublish_Confirm_Website_OnlyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Unpublish_Confirm_Website_OnlyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_unpublish_confirm_website_only(inputs)
	return cs_property_unpublish_confirm_website_only(inputs)
});